/**
 * 품셈해설 셸의 열 치수 — **헤더와 본문이 같은 값을 봐야 한다.**
 * 계산 근거는 `features/docs/components/docsShell.constant.ts` 와 같다.
 * (22rem − 14px = 20.875rem)
 *
 * 결과 목록이 도움말 사이드바보다 넓은 이유: 카드 한 장이 부문·코드·개정 배지에
 * 품셈명 한 줄, 직종 배지까지 담는다. 16rem 대에서는 품셈명이 세 줄로 접힌다.
 */
export const PUMSEM_SHELL = {
  /** 결과 목록 열 + 본문 열. */
  grid: 'lg:grid-cols-[22rem_minmax(0,1fr)]',
  /** 헤더 좌측 존. 결과 목록 폭 − 헤더 gutter. */
  headerStart: 'lg:w-[20.875rem]',
} as const;
